<template>
  <div id="orders-details" class="detail-page">
    <div v-if="!canViewOrders" class="container">
      <b-alert show variant="danger">
        {{ getContentItem("MissingOpenOrdersAccess") }}
      </b-alert>
    </div>
    <div v-if="isBusy" class="d-flex align-items-center justify-content-center">
      <loading-spinner />
    </div>
    <div v-else-if="notFound" class="d-flex align-items-center justify-content-center">
      <order-not-found :order-number="orderNumber" />
    </div>
    <div v-else class="container">
      <order-details-header :data="getHeaderDetail()" />
      <order-details-grid :details="getGridDetail()" />
      <related-invoices :related-invoices="getRelatedInvoices()" />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { ErrorLogService, OrderService } from "@/services";

  import { LoadingSpinner } from "@/components/Elements";

  import OrderDetailsHeader from "./OrderDetailsHeader";
  import OrderDetailsGrid from "./OrderDetailsGrid";
  import OrderNotFound from "./OrderNotFound";
  import RelatedInvoices from "./RelatedInvoices";

  export default {
    components: {
      OrderDetailsHeader,
      OrderDetailsGrid,
      OrderNotFound,
      RelatedInvoices,
      LoadingSpinner
    },

    computed: {
      ...mapGetters([
        "user",
        "getContentItem",
        "hasPermission",
        "canSeeAnyPrice",
        "availableDealerCodes",
        "activeAccountId"
      ]),
      canViewOrders() {
        return this.hasPermission("CanSeeOrders");
      }
    },
    props: {
      orderNumber: {
        type: String,
        default: null
      },
      orderSource: {
        type: String,
        default: null
      },
      dealerCode: {
        type: String,
        default: null
      },
      salesOrg: {
        type: String,
        default: null
      }
    },
    data: () => ({
      orderDetails: null,
      isBusy: true,
      notFound: false
    }),
    mounted() {
      this.fetchOrderDetails();
    },
    methods: {
      fetchOrderDetails: function() {
        var dealerCode = "";
        if(this.dealerCode){
          dealerCode = this.dealerCode;
        }
        else{
          dealerCode = this.user.DealerCode;
        }
        return OrderService.GetOrderDetails(
          this.activeAccountId,
          this.user.UserId,
          this.orderNumber,
          this.orderSource,
          dealerCode,
          this.salesOrg
        )
          .then(results => {
            this.orderDetails = results.data;
          })
          .catch(err => {
            ErrorLogService.LogException(err);
          })
          .finally(() => {
            this.isBusy = false;
            if (!this.orderDetails || !this.orderDetails.OrderNumber) {
              this.notFound = true;
            }
          });
      },

      getHeaderDetail: function() {
        return {
          ...this.orderDetails,
          isMcfOrder: this.orderDetails.OrderSource === "Mcf",
          isRpiOrder: this.orderDetails.OrderSource === "Rpi",
          isPartsFastPartsFree: this.orderDetails.IsPartsFastPartsFree
        };
      },

      getGridDetail: function() {
        return {
          ...this.orderDetails,
          isMcfOrder: this.orderDetails.OrderSource === "Mcf",
          showPrices: this.canSeeAnyPrice && !this.hasPermission("HideInvoicePricing"),
          showSubtotal: !this.hasPermission("HideInvoicePricing")
        };
      },

      getRelatedInvoices: function() {
        return this.orderDetails.RelatedInvoices;
      }
    }
  };
</script>

<style lang="scss">
#orders-details {
  tfoot {
    .row-sub-total {
      td {
        font-weight: bold;
      }
    }
  }
}
</style>
